import type { Component, Entity2D } from '../../odie';

import { SpiderBlockProps } from '../defs/block';
import { SpiderBlockView } from '../views/blocks/SpiderBlockView';

export type SpiderBlockComponentOptions = {
  props: SpiderBlockProps;
};

/*
  chain block component
*/
export class SpiderBlockComponent implements Component {
  public static readonly NAME = 'blockSpider';

  public entity!: Entity2D;
  public view!: SpiderBlockView;
  public movedDown = false;

  public init(options: SpiderBlockComponentOptions): void {
    this.view = new SpiderBlockView(options.props);
  }
}
